<template>
  <div class="sornBG lightBG">
    <h1>My Account</h1>
    <v-container class="col-3">
      <v-list dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-btn
                rounded
                class="sidebar-btn white--text"
                color="primary"
                block
                @click="goToChangePassword"
              >Change Password</v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-btn
                rounded
                class="sidebar-btn white--text"
                color="primary"
                block
                @click="backtoAppSelection"
              >Back</v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  name: 'appSelection',
  data() {
    return {
      appButtons: [],
    }
  },
  async mounted() {},
  methods: {
    ...mapActions(['getApps', 'getUser', 'logoffUser']),
    ...mapMutations(['setAccountComponent']),
    goToChangePassword() {
      this.setAccountComponent('ChangePassword')
    },
    backtoAppSelection() {
      this.$router.push('/')
    },
  },
  computed: {
    ...mapState(['applications', 'user', 'userToAppMappings']),
  },
  watch: {},
}
</script>

<style>
.sornBG {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.center {
  align-items: center;
}
</style>
